import TeamCard from "./TeamCard";
import ScoreDisplay from "./ScoreDisplay";
import { getGameStatusClass, getGameStatusText, hasGameStarted } from "./statusHelpers";
import "./cardPartido.sass";

/**
 * Componente CardPartido - Renderiza una tarjeta de un partido de fútbol
 * 
 * Estructura visual:
 * [Left Team] [Score] [Right Team]
 * 
 * Estados del partido (class):
 * - clarosports-next-game: Próximo partido
 * - clarosports-in-progress-game: Partido en vivo
 * - clarosports-finished-game: Partido finalizado
 * - clarosports-error-game: Error
 * 
 * Estados del equipo (left_class, right_class):
 * - clarosports-winner: Equipo ganando
 * - clarosports-loser: Equipo perdiendo
 * - clarosports-draw: Empate
 */
export default function CardPartido({ game, gameIndex = 0, animationTrigger = 0 }) {
  if (!game) {
    return <div className="card-partido error">No hay datos del partido</div>;
  }

  const {
    left_name,
    left_short_name,
    left_image,
    left_score,
    left_class,
    right_name,
    right_short_name,
    right_image,
    right_score,
    right_class,
    class: gameStatus,
    score,
    period_title,
    date,
    phase,
    venue_name,
  } = game;

  const started = hasGameStarted(gameStatus);

  // Calcular el delay basado en el índice
  // animationTrigger força re-render cuando cambia de página
  const animationDelay = `${gameIndex * 0.2}s`;

  return (
    <div 
      className={`card-partido ${getGameStatusClass(gameStatus)}`}
      style={{ '--animation-delay': animationDelay }}
    >
      {/* Encabezado del partido */}

      {/* Contenido principal - Teams y Score */}
      <div className="partido-content">
        <TeamCard
          name={left_name}
          shortName={left_name}
          image={left_image}
          statusClass={left_class}
          position="left"
        />

        <ScoreDisplay
          leftScore={left_score}
          rightScore={right_score}
          score={score}
          gameStatus={gameStatus}
          periodTitle={period_title}
        />

        <TeamCard
          name={right_name}
          shortName={right_name}
          image={right_image}
          statusClass={right_class}
          position="right"
        />
      </div>

      {/* Footer - Información adicional */}
      <div className="partido-footer">

        <div className="footer-horario">
          <span className={gameStatus === "clarosports-in-progress-game" ?
           "horario-game live-game":"horario-game"}>{period_title}</span>
        </div>
      </div>


    </div>
  );
}
